import React from 'react';
import { Route } from 'react-router-dom';
import Routes from './routes';
import ReinitialisationCredentialsApresChangementRL from './reinitialisation';
import { getPath } from '../../../utils/router';

const ChangementResponsableLegal = () => {
    return (
        <>
            <Route
                path={getPath(Routes.subroutes.reinitialisation)}
                render={(subProps) => (
                    <ReinitialisationCredentialsApresChangementRL {...subProps} />
                )}
            />
        </>
    );
};

export default ChangementResponsableLegal;
